<template>
  <div>
    <v-menu
      :close-on-content-click="false"
      transition="scale-transition"
      content-class="elevation-6"
      origin="bottom center"
      rounded="lg"
      offset-y
      left
      top
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-bind="attrs" v-on="{ ...tooltip, ...menu }" icon>
              <v-icon small :color="realty_type ? 'green' : 'red'">
                mdi-home-alert-outline
              </v-icon>
            </v-btn>
          </template>
          {{ $t('appointment.formCreate.labels.type') }}
        </v-tooltip>
      </template>
      <v-list max-width="180" class="pa-0">
        <v-list-item-group class="pa-3">
          <v-select
            v-model="realty_type"
            @change="handleUpdateDetails"
            :label="$t('realty.formCreate.realtyType')"
            :items="realtyTypes"
            hide-details="auto"
            item-value="value"
            item-text="name"
            outlined
          />
        </v-list-item-group>
      </v-list>
    </v-menu>

    <v-menu
      :close-on-content-click="false"
      transition="scale-transition"
      content-class="elevation-6"
      origin="bottom center"
      rounded="lg"
      offset-y
      left
      top
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-bind="attrs" v-on="{ ...tooltip, ...menu }" icon>
              <v-icon small :color="furnishingColor(furnishing)">
                mdi-sofa-single-outline
              </v-icon>
            </v-btn>
          </template>
          {{ $t('appointment.formCreate.labels.furnished.label') }}
        </v-tooltip>
      </template>
      <v-list max-width="180" class="pa-0">
        <v-list-item-group class="pa-3">
          <p class="mb-0">
            {{ $t('appointment.formCreate.labels.furnished.label') }}
          </p>
          <v-divider class="mt-2 mb-4" />
          <template v-for="(option, index) in furnishingOptions">
            <v-divider
              v-if="index"
              :key="`divider-${option.value}`"
              class="my-1 white"
            />
            <v-switch
              :key="option.value"
              @change="
                () => {
                  furnishing = option.value
                  handleUpdateDetails()
                }
              "
              v-model="furnishing"
              :value="option.value"
              :ripple="false"
              :disabled="isLoading"
              :label="option.name"
              class="my-0 py-0"
              hide-details="auto"
              dense
              inset
            />
          </template>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <v-menu
      :close-on-content-click="false"
      transition="scale-transition"
      content-class="elevation-6"
      origin="bottom center"
      rounded="lg"
      offset-y
      left
      top
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-bind="attrs" v-on="{ ...tooltip, ...menu }" icon>
              <v-icon small :color="trousseau ? 'green' : 'red'">
                mdi-bed-outline
              </v-icon>
            </v-btn>
          </template>
          {{ $t('appointment.formCreate.labels.trousseau.label') }}
        </v-tooltip>
      </template>
      <v-list max-width="180" class="pa-0">
        <v-list-item-group class="pa-3">
          <v-switch
            @change="handleUpdateDetails"
            v-model="trousseau"
            :ripple="false"
            :disabled="isLoading"
            :label="$t('appointment.formCreate.labels.trousseau.label')"
            class="my-0 py-0"
            hide-details="auto"
            dense
            inset
          />
        </v-list-item-group>
      </v-list>
    </v-menu>

    <v-menu
      :close-on-content-click="false"
      transition="scale-transition"
      content-class="elevation-6"
      origin="bottom center"
      rounded="lg"
      offset-y
      left
      top
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-bind="attrs" v-on="{ ...tooltip, ...menu }" icon>
              <v-icon small :color="statusColor(paintingStatus)">
                mdi-brush-variant
              </v-icon>
            </v-btn>
          </template>
          {{ $t('appointment.formCreate.labels.painting.label') }}
        </v-tooltip>
      </template>
      <v-list max-width="180" class="pa-0">
        <v-list-item-group class="pa-3">
          <p class="mb-0">
            {{ $t('appointment.formCreate.labels.painting.label') }}
          </p>
          <v-divider class="mt-2 mb-4" />
          <v-switch
            @change="
              () => {
                paintingStatus = 'NEW'
                handleUpdateDetails()
              }
            "
            v-model="paintingStatus"
            value="NEW"
            :ripple="false"
            :disabled="isLoading"
            :label="$t('appointment.formCreate.labels.painting.new')"
            class="my-0 py-0"
            hide-details="auto"
            dense
            inset
          />
          <v-divider class="my-1 white" />
          <v-switch
            @change="
              () => {
                paintingStatus = 'WORN'
                handleUpdateDetails()
              }
            "
            v-model="paintingStatus"
            value="WORN"
            :ripple="false"
            :disabled="isLoading"
            :label="$t('appointment.formCreate.labels.painting.worn')"
            class="my-0 py-0"
            hide-details="auto"
            dense
            inset
          />
          <v-divider class="my-1 white" />
          <v-switch
            @change="
              () => {
                paintingStatus = 'HOST_CRITERIA'
                handleUpdateDetails()
              }
            "
            v-model="paintingStatus"
            value="HOST_CRITERIA"
            :ripple="false"
            :disabled="isLoading"
            :label="$t('appointment.formCreate.labels.painting.hostCriteria')"
            class="my-0 py-0"
            hide-details="auto"
            dense
            inset
          />
        </v-list-item-group>
      </v-list>
    </v-menu>

    <v-menu
      :close-on-content-click="false"
      transition="scale-transition"
      content-class="elevation-6"
      origin="bottom center"
      rounded="lg"
      offset-y
      left
      top
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-bind="attrs" v-on="{ ...tooltip, ...menu }" icon>
              <v-icon small :color="squareMeters ? 'green' : 'red'">
                mdi-ruler-square
              </v-icon>
            </v-btn>
          </template>
          {{ $t('appointment.formCreate.labels.meterage.label') }}
        </v-tooltip>
      </template>
      <v-list max-width="150" class="pa-0">
        <v-list-item-group class="pa-3">
          <p class="mb-0">Metragem</p>
          <v-divider class="mt-2 mb-4" />
          <v-text-field
            @click:append="handleUpdateDetails"
            v-model="privateAreaMeters"
            :disabled="isLoading"
            :label="$t('appointment.formCreate.labels.meterage.privateArea')"
            :append-icon="saveIcon"
            class="small"
            hide-details="auto"
            outlined
            dense
          />
          <v-divider class="my-2 white" />
          <v-text-field
            @click:append="handleUpdateDetails"
            v-model="squareMeters"
            :disabled="isLoading"
            :label="$t('appointment.formCreate.labels.meterage.totalArea')"
            :append-icon="saveIcon"
            class="small"
            hide-details="auto"
            outlined
            dense
          />
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { realtyTypes } from '@/util/enums'
import { FURNISHING, fromFurnishing, furnishingOptions, toFurnishing } from '@/util/furnishing'

export default {
  name: 'RealtySearchDetails',

  props: {
    realty: {
      type: Object,
    },
  },

  data() {
    return {
      realtyId: this.realty.id,
      code: this.realty.code,
      address: this.realty.address,
      description: this.realty.description,
      paintingStatus: this.realty.painting_status
        ? this.realty.painting_status
        : 'HOST_CRITERIA',
      furnishing: toFurnishing(this.realty.furnished, this.realty.semi_furnished),
      furnishingOptions: furnishingOptions((key) => this.$t(key)),
      trousseau: this.realty.trousseau,
      squareMeters: this.realty.square_meters,
      privateAreaMeters: this.realty.private_area_meters,
      realty_type: this.realty.type,

      saveIcon: 'mdi-content-save-outline',
      isLoading: false,
      realtyTypes,
    }
  },

  computed: {
    ...mapGetters(['appointmentFields']),
  },

  methods: {
    ...mapActions(['quickRealtyUpdate']),

    statusColor(status) {
      switch (status) {
        case 'NEW':
          return 'green'
        case 'WORN':
          return 'red'
        case 'HOST_CRITERIA':
          return 'orange'
        default:
          return 'grey'
      }
    },

    furnishingColor(furnishing) {
      switch (furnishing) {
        case FURNISHING.FURNISHED:
          return 'green'
        case FURNISHING.SEMI_FURNISHED:
          return 'orange'
        default:
          return 'red'
      }
    },

    handleUpdateDetails() {
      this.$nextTick(() => {
        if (this.appointmentFields.date) {
          this.saveIcon = 'mdi-content-save-edit-outline'

          const realty = {
            realty_id: this.realtyId,
            private_area_meters: this.privateAreaMeters,
            painting_status: this.paintingStatus,
            square_meters: this.squareMeters,
            ...fromFurnishing(this.furnishing),
            trousseau: this.trousseau,
            realty_type: this.realty_type,
          }

          this.isLoading = true

          this.quickRealtyUpdate(realty).finally(() => {
            this.isLoading = false
            this.statusColor(this.paintingStatus)
            this.saveIcon = 'mdi-content-save-outline'

            this.$emit('updateSelectedItem', realty?.realty_id)
          })
        }
      })
    },
  },
}
</script>
